// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"24ab2502","241":"ac6f9526","421":"e49b7b8f","508":"7d27373c","632":"6f51901e","711":"7ef0167e","807":"9cbd9791","950":"1c79a7c4","957":"d247ce90"}[chunkId] + ".chunk.js";
};